<template>
  <div class="page-container">
    <ResearchIns/>
  </div>
</template>

<script>
import ResearchIns from '@/components/research/index.vue'
export default {
  components: {
    ResearchIns
  },
}
</script>

<style scoped>
.page-container {
  padding-top: 70px; /* 为固定导航栏预留空间 */
}
</style>
